import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as _ from 'lodash';
import { LoaderEvent } from '../../../shared/message.event';
import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';

@Component({
  selector: 'linkactivitiesunit-modal',
  templateUrl: './link-activities-unit.component.html',
  styleUrls: ['./link-activities-unit.component.css'],
  providers: [LoaderEvent],
  exportAs: 'linkActivitiesUnitPopup'
})

export class LinkActivitiesUnitPopupComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private stringConstants = CONSTANT_MESSAGES;
  @Input() cancleButton;
  @Output() notify = new EventEmitter<any>();
  @Output() notifyForEditGroup = new EventEmitter<any>();

  private facilityList;
  private selectedFacilities = [];
  private resObj = {
    activities: [],
    sendDataFlag: false
  };
  private editGroup = false;
  private editMemberObj;
  private modalTitle;
  private units = [];
  private selectedFacility;
  private activities = [];
  private selectedUnit;
  constructor(public router: Router, private loaderEvent: LoaderEvent) { }

  ngOnInit() {
    this.getFacility();
  }

  getFacility() {
    let that = this;
    that.facilityList = [];
    let facilityData = [];
    if (localStorage.getItem('vendor_facilityData')) {
      facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
      facilityData.forEach(data => {
        data.data.forEach(facility => {
            that.facilityList.push(facility);
        });
      });
      this.selectedFacility = that.facilityList[0]
    }
  }
  /* when activity checkbox is checked */
  addFacilityToLink(item) {
    console.log(item)
    this.selectedFacility = this.facilityList.filter(facility => {
      return facility._id == item
    })[0]
    this.units = this.selectedFacility.unitNames
    this.selectedUnit = this.units[0]
  }

  /*addUnitsToLink(item) {
      this.selectedUnit = this.units.filter(unit => {
        return item == unit
      })[0]
  }*/

  addSelections(){
    let activity = {
      activityName:this.selectedFacility.name,
      activityId:this.selectedFacility._id,
      // unitName: this.selectedUnit
    }
    if( this.activities.map(activity => { return activity.activityId}).indexOf(activity.activityId) == -1){
        this.activities.push(activity)
    }
  }

  /* When the popup is triggered */
  public showChildModal(memberObj?): void {
    this.editGroup = memberObj ? true : false;
    this.modalTitle = CONSTANT_MESSAGES.LINK_ACTIVITY_TITLE;
    this.editMemberObj = memberObj;
    // this.updateGroup(memberObj);
    this.childModal.config.backdrop = false;
    this.childModal.config.keyboard = false;
    this.childModal.show();
  }
  // Hiding this model
  public hideChildModal(): void {
    try {
      this.childModal.hide();
    } catch (e) {
      console.log(e);
    }
  }

  // returns the value back to parent
  onClickOk() {
    this.editMemberObj.activities = this.activities,
    this.notifyForEditGroup.emit(this.editMemberObj);
  }
  // When the popup closes
  closePopup() {
    try {
      this.notify.emit(false);
    } catch (e) {
      console.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/add-member/link-activity-unit/link-activities-unit.component.ts